import { styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { PAGE_BACKGROUND } from '@theme';

export const StyledHero = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '0 2.5rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.down('xs')]: {
    padding: '0 1.25rem',
  },
}));

export const StyledHeadline = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  maxWidth: '700px',
  width: '100%',
  marginTop: '1.5rem',
}));

export const StyledHeading = styled('div')(({ theme }) => ({
  padding: '2rem 2.5rem',
  background: PAGE_BACKGROUND,
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
}));

export const StyledButtonContainer = styled('div')(({ theme }) => ({
  margin: '1.5rem 0',
  display: 'flex',
  justifyContent: 'flex-end',
}));
